module.exports = __webpack_public_path__ + "static/img/Toxic chemical-01.00f663a0.jpg";